import React, { useEffect } from 'react';
import { IItemForGetShortInfo, IGetSubCategoriesShort, IGetSubCategoriesArguments } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getSubCategoriesShortInfoV2 } from 'backend/subcategories';
import FormSelect from 'components/Select/FormSelect';
import style from './ModificationDishSubCategorySelect.module.scss';

interface IProps {
	setFetchedModificationDishSubCategories: (value: IItemForGetShortInfo[]) => void;
	setModificationDishSubCategory: (value: Nullable<string>) => void;
	selectedModificationDishCategory: Nullable<string>;
}

export const ModificationDishSubCategorySelect: React.FC<IProps> = React.memo(
	({ setFetchedModificationDishSubCategories, setModificationDishSubCategory, selectedModificationDishCategory }) => {
		const { response, loading, refetch, responseError } = useFetchData<
			IGetSubCategoriesShort,
			IGetSubCategoriesArguments
		>(selectedModificationDishCategory ? getSubCategoriesShortInfoV2 : null, {
			categoryId: selectedModificationDishCategory ? selectedModificationDishCategory : '',
		});

		useEffect(() => {
			refetch();
		}, [selectedModificationDishCategory]);

		useEffect(() => {
			response && setFetchedModificationDishSubCategories(response.data.subCategories);
		}, [response]);

		return (
			<FormSelect
				name="selectedModificationDishSubCategory"
				label="subcategoryLabel"
				formItemClassName={style.container}
				options={response?.data.subCategories}
				fetchError={responseError}
				loading={loading}
				onRefetch={refetch}
				disabled={!selectedModificationDishCategory || loading}
				onChange={setModificationDishSubCategory}
				onMouseDown={(e) => e.stopPropagation()}
				onClick={(e) => e.stopPropagation()}
			/>
		);
	},
);
